
(function () {
  'use strict';

  var root = document.querySelector('[data-pb-eab-root]');
  if (!root) return;

  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  // Gallery
  var mainImage = qs('#pb-eab-main-image');
  qsa('[data-pb-eab-gallery-src]').forEach(function (button) {
    button.addEventListener('click', function () {
      qsa('[data-pb-eab-gallery-src]').forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');
      mainImage.src = button.getAttribute('data-pb-eab-gallery-src');
      mainImage.alt = button.getAttribute('data-pb-eab-gallery-alt') || '';
    });
  });

  // Variant/size selection
  var select = qs('#pb-eab-variant-select');
  var price = qs('#pb-eab-price');
  var compare = qs('#pb-eab-compare');
  var mobilePrice = qs('#pb-eab-mobile-price');
  var atc = qs('#product-add-to-cart');
  var affirm = qs('.pb-eab__affirm');

  function updateVariant(button) {
    var id = button.getAttribute('data-variant-id');
    var available = button.getAttribute('data-available') === 'true';

    qsa('[data-pb-eab-variant]').forEach(function (b) {
      var active = b === button;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-checked', active ? 'true' : 'false');
    });

    select.value = id;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    var priceMoney = button.getAttribute('data-price') || '';
    var compareMoney = button.getAttribute('data-compare') || '';
    var cents = button.getAttribute('data-price-cents') || '';

    price.textContent = priceMoney;
    mobilePrice.textContent = priceMoney;

    if (compareMoney) {
      compare.textContent = compareMoney;
      compare.classList.remove('is-hidden');
    } else {
      compare.textContent = '';
      compare.classList.add('is-hidden');
    }

    atc.disabled = !available;
    var label = atc.querySelector('.hs-add--to--cart-product-page');
    if (label) label.textContent = available ? 'Add to Cart' : 'Out of Stock';

    if (affirm && cents) {
      affirm.setAttribute('data-amount', cents);
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        try { window.affirm.ui.refresh(); } catch (e) {}
      }
    }

    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  }

  qsa('[data-pb-eab-variant]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.getAttribute('data-available') !== 'true') return;
      updateVariant(button);
    });
  });

  // Position switching
  qsa('[data-pb-eab-motion]').forEach(function (button) {
    button.addEventListener('click', function () {
      qsa('[data-pb-eab-motion]').forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');
      var img = qs('#pb-eab-motion-image');
      img.src = button.getAttribute('data-pb-eab-motion');
      img.alt = button.getAttribute('data-motion-alt') || '';
    });
  });

  // Split King switching
  qsa('[data-pb-eab-split]').forEach(function (button) {
    button.addEventListener('click', function () {
      qsa('[data-pb-eab-split]').forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');
      var img = qs('#pb-eab-split-image');
      img.src = button.getAttribute('data-pb-eab-split');
      img.alt = button.getAttribute('data-split-alt') || '';
    });
  });

  // FAQ +/-
  qsa('.pb-eab__faq-list details').forEach(function (details) {
    details.addEventListener('toggle', function () {
      var indicator = details.querySelector('summary span');
      if (indicator) indicator.textContent = details.open ? '−' : '+';
    });
  });

  // Image lightbox
  var lightbox = qs('[data-pb-eab-lightbox]');
  var lightboxImage = qs('[data-pb-eab-lightbox-image]');
  function openLightbox() {
    lightboxImage.src = mainImage.src;
    lightboxImage.alt = mainImage.alt;
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  var openLB = qs('[data-pb-eab-lightbox-open]');
  var closeLB = qs('[data-pb-eab-lightbox-close]');
  if (openLB) openLB.addEventListener('click', openLightbox);
  if (closeLB) closeLB.addEventListener('click', closeLightbox);
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });

  // Size guide modal
  var modal = qs('[data-pb-eab-size-guide-modal]');
  var openModalButton = qs('[data-pb-eab-size-guide-open]');
  var closeModalButton = qs('[data-pb-eab-size-guide-close]');
  var lastFocused = null;

  function openModal() {
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (closeModalButton) closeModalButton.focus();
  }
  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }
  if (openModalButton) openModalButton.addEventListener('click', openModal);
  if (closeModalButton) closeModalButton.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (lightbox && !lightbox.hidden) closeLightbox();
    if (modal && !modal.hidden) closeModal();
  });

  // Mobile sticky ATC submits the real Shopify product form.
  var mobileAtc = qs('[data-pb-eab-mobile-atc]');
  var form = qs('#add-to-cart-form');
  if (mobileAtc && form) {
    mobileAtc.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(atc);
      else atc.click();
    });
  }
})();
